<app-card *ngIf="listTree.length>0" [isHeader]=true [title]="'Classification'|translate">

    <table >
        <thead *ngIf="listTree.length>0"><a style="color: #0000FF" (click)="sendIDfromtree('')">Racine</a></thead>
    
        <tbody>
          <tr *ngFor="let item of listTree">
            <td><a style="color: #0000FF" (click)="sendIDfromtree(item.cateId)" >{{item.cateId}}</a>
            </td>
            <td><a style="color: #0000FF" (click)="sendIDfromtree(item.cateId)">{{item.cateNm}}</a></td>
           
            
          </tr>
        </tbody>
      </table>
    </app-card>
    